<template>
    <div class="face-container" id="page-face">
        <img class="face-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/new/fb-title.png" alt="" />
        <div class="face-content">
            <div class="house">
                <div class="fb-window">
                    <div class="fb-page" data-href="https://www.facebook.com/happybigboss" data-tabs="timeline"
                        data-width="500" data-height="470" data-small-header="false" data-adapt-container-width="true"
                        data-hide-cover="false" data-show-facepile="true">
                        <blockquote cite="https://www.facebook.com/happybigboss" class="fb-xfbml-parse-ignore"><a
                                href="https://www.facebook.com/happybigboss">歡樂大東家-回到古代 做點買賣</a></blockquote>
                    </div>
                </div>
                <!-- <div class="house-btn">
                    <span></span>
                    <span></span>
                </div> -->
            </div>
        </div>
        <div class="coins-top-left">
            <img class="face-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/coin.png" alt="" />
        </div>
        <div class="coins-buttom-left">
            <img class="face-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/coin.png" alt="" />
        </div>
    </div>
</template>
<script>
import jsonData from "@/assets/data.js";
export default {
    data() {
        return {
            bottomItems: [
                { label: "綜合", value: "all" },
                { label: "公告", value: "announcement" },
                { label: "活動", value: "activity" },
                { label: "新闻", value: "face" },
            ],
            active_item: "all",
        };
    },
    mounted() {
        this.initFaceBook();
        this.$nextTick(() => {
            new this.$Swiper(".face-swiper-container", {
                loop: true,
                speed: 500,
                // 如果需要分页器
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, // 允许点击小圆点跳转
                },
                //如果需要自动切换海报
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false, // 手动切换之后继续自动轮播
                },
            });
        });

    },

    computed: {
        faceData() {
            let data = [];
            let formatData = (type, datas = []) => {
                let type_data = [];
                datas.forEach((e) => {
                    type_data.push({
                        title: e.title,
                        time: this.formatTime(e.time),
                        id: e.id,
                        type,
                    });
                });
                return type_data;
            };
            if (this.active_item == "all") {
                let all = [];
                this.bottomItems.forEach((element) => {
                    let item_data = jsonData[element.value] || [];
                    item_data = formatData(element.value, item_data);
                    all = all.concat(item_data);
                });
                data = all;
            } else {
                data = jsonData[this.active_item] || [];
                data = formatData(this.active_item, data);
            }
            return data;
        },
    },

    methods: {
        jumpLink(path, item) {
            if (path.includes("detail")) {
                let type = item.type,
                    id = item.id;
                this.$router.push({ path, query: { type, id } });
            } else {
                this.$router.push(path);
            }
        },

        formatTime(time) {
            return time.replace(/-/g, ".");
        },

        changeItem(item) {
            this.active_item = item;
        },
        initFaceBook() {
            (window).faceBooke = (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.nonce = "AlZYDPf5";
                js.src = 'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v14.0&appId= 309746810979871&autoLogAppEvents=1';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    },
};
</script>
<style scoped lang="scss" src="./scss/face.scss">
</style>